import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

function SvgComponent(props) {
    return (
        <Svg width={52} height={81} viewBox="0 0 52 81" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <Path
                d="M23.038.75c14.703 0 26.03 8.71 26.03 20.822 0 6.598-3.334 12.937-8.507 16.343 5.99 3.02 10.692 9.4 10.692 17.56 0 13.699-11.651 24.775-28.423 24.775-9.83 0-17.644-3.38-21.877-7.936l-.202-.217.002-.297.105-19.344.013-2.646 1.376 2.26c4.23 6.947 11.995 10.872 18.918 10.872 3.367 0 6.08-.855 7.932-2.276 1.835-1.408 2.866-3.401 2.866-5.814 0-2.512-1.05-4.516-3.095-5.921-2.078-1.43-5.238-2.273-9.471-2.273H14.59V32.574h4.39c3.548 0 6.458-.762 8.456-2.086 1.972-1.306 3.071-3.162 3.071-5.484 0-2.098-.898-3.827-2.546-5.054-1.668-1.241-4.148-1.996-7.315-1.996-7.833 0-13.66 3.904-17.501 9.058l-1.31 1.758-.042-2.192-.311-16.64-.005-.235.13-.195c1.778-2.665 4.891-4.848 8.64-6.363C14.008 1.625 18.474.75 23.038.75z"
                fill={designSystem.colors.neutral900}
                stroke={ds.colorValue.icon.brand}
                strokeWidth={1.5}
            />
        </Svg>
    );
}

export default SvgComponent;
